import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { trackerModalComponent } from 'src/app/component/modals/tracker-modal/tracker-modal.component';
import { MapService } from '../map/map.service';

@Injectable()
export class DialogService {

  dialogRef: MatDialogRef<any>;
  constructor(
    public dialog: MatDialog,
    private mapService: MapService
  ) { }
  closeDialog() {
    this.dialogRef.close();
    this.dialogRef = null;
  }

  setDialogRef(dialogRef) {
    this.dialogRef = dialogRef;
  }

  openDialog(spotName) {
    if(this.dialogRef == null){
      this.dialogRef = this.dialog.open(trackerModalComponent, {
        panelClass: 'pos-absolute',
        hasBackdrop: false,
        data: {name: spotName}
      });
  
      this.dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    } else {
      this.closeDialog();
      this.openDialog(spotName);
    }
  }
}